'use client';

import type { Collapsible as CollapsiblePrimitive } from '@base-ui/react/collapsible';
import { cn } from '@zealot/ui/lib/utils';
import { ChevronRight } from 'lucide-react';

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from './collapsible';

type SimpleCollapsibleProps = {
  title: React.ReactNode;
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: CollapsiblePrimitive.Root.Props['onOpenChange'];
  disabled?: boolean;
  icon?: React.ReactNode;
  className?: string;
  triggerClassName?: string;
  contentClassName?: string;
  children: React.ReactNode;
};

const SimpleCollapsible = ({
  title,
  open,
  defaultOpen,
  onOpenChange,
  disabled,
  icon,
  className,
  triggerClassName,
  contentClassName,
  children,
}: SimpleCollapsibleProps) => {
  return (
    <Collapsible
      open={open}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      disabled={disabled}
      className={className}
    >
      <CollapsibleTrigger
        className={cn(
          'flex w-full cursor-pointer items-center gap-2 py-2 font-medium disabled:cursor-not-allowed disabled:opacity-50 [&[data-panel-open]>span[data-slot=collapsible-icon]]:rotate-90',
          triggerClassName,
        )}
      >
        <span data-slot="collapsible-icon" className="transition-transform duration-200">
          {icon ?? <ChevronRight className="size-4" />}
        </span>
        {title}
      </CollapsibleTrigger>
      <CollapsibleContent className={contentClassName}>{children}</CollapsibleContent>
    </Collapsible>
  );
};

export type { SimpleCollapsibleProps };
export { SimpleCollapsible };
